import SectionMessage from '@atlaskit/section-message';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { MAINTENANCE_BANNER_TARGET_PAGES, MAINTENANCE_STATE, MAINTENANCE_TYPE } from '@atlassian/mpac-types';
import { UserGeneratedHtml } from '@atlassian/mpac-ui';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MAINTENANCE_BANNER_TEST_ID = 'marketplace-maintenance-banner';
export default function MaintenanceBanner() {
  const {
    maintenanceBannerConfiguration
  } = useFeatureFlags();
  if (!maintenanceBannerConfiguration) {
    return null;
  }
  if ((maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.type) === MAINTENANCE_TYPE.NONE || (maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.targetPages) === MAINTENANCE_BANNER_TARGET_PAGES.MARKETPLACE_PARTNER_PORTAL) {
    return null;
  }
  let appearance = 'information';
  if ((maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.type) === MAINTENANCE_TYPE.WITH_CAPABILITIES_DISRUPTION && (maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.state) === MAINTENANCE_STATE.IN_PROGRESS) {
    appearance = 'warning';
  }
  return /*#__PURE__*/_jsx(SectionMessage, {
    appearance: appearance,
    testId: MAINTENANCE_BANNER_TEST_ID,
    children: /*#__PURE__*/_jsx(UserGeneratedHtml, {
      dangerousHtml: maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.content,
      extraStyle: {
        fontSize: '14px',
        lineHeight: '20px'
      }
    })
  });
}